import type { FaireProductEntity } from "../../entity_types/product";

export const p_8t3rgdj72m: FaireProductEntity = {
  token: "p_8t3rgdj72m",
  type: "product",
  name: "Origami Japanese Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/394b0075df149710dff79a02cd11b95a9c7aac3e95983be9c77d9726c9643968.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/118856abd1ed26e17d3cd6cb9710f55ae85141329311a123d4e7ad0256cc5b99.jpeg",
    "https://cdn.faire.com/fastly/a20afced7cdb4c177054e653c442b6d6d0b77147d6b931d8e5affd944316522b.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these Origami washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Sakura, Warlord, O-Gi Fan, Maneki Neko, Japanese Foods, Origami Cranes, Ukiyo Mt. Fuji \nSpecifications\n\n * Type: Washi stickers \n * Design: Origami \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:07.200Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
